import React, { useEffect, useMemo, useState } from "react";

import axios from "axios";
import { API_ENDPOINT } from "../../../services/api/resources";
import DropdownBtnOutlined from "../../../components/Dashboard/DropdownButtons/DropdownBtnOutlined/DropdownBtnOutlined";
import DTextInput from "../../../components/Dashboard/DashboardInputs/DTextInput";
import DButton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import {
  Checkbox,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Modal,
  Fade,
  TextField,
  Typography,
} from "@mui/material";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";
import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";
import deletePopupImg from "../../../assets/images/png/Group 2@2x.png";

const VendorItemMapping = ({ org_token, auth_token, vendorToken }) => {
  const [itemsData, setItemsData] = useState([]);
 const [selectedCategory, setSelectedCategory] = useState("");
const [selectedItem, setSelectedItem] = useState("");
const [bulkMode, setBulkMode] = useState(false);
const [itemSearch, setItemSearch] = useState("");
const [selectedItemTokens, setSelectedItemTokens] = useState([]);

const [mappedItems, setMappedItems] = useState([]);

const [successMessage, setSuccessMessage] = useState("");
const [status, setStatus] = useState({
  show: false,
  type: "success", 
  message: "",
});


  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  

  useEffect(() => {
    if (!org_token || !auth_token) return;

    const fetchItems = async () => {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("org_token", org_token);
        // formData.append("page", 1);
        const res = await axios.post(
          API_ENDPOINT.buyer_all_item_list,
          formData,
          { headers: { Authorization: `Bearer ${auth_token}` } }
        );

        setItemsData(res?.data?.results || []);
      } catch {
        setError("Failed to load items");
      } finally {
        setLoading(false);
      }
    };

    fetchItems();
  }, [org_token, auth_token]);

  const refreshMappedItems = async () => {
    if (!vendorToken || !auth_token) return;

    try {
      const res = await axios.post(
        API_ENDPOINT.vendors_item_mapping_list,
        {
          vendor_token: vendorToken,
          organization_token: org_token,
        },
        {
          headers: { Authorization: `Bearer ${auth_token}` },
        }
      );

      setMappedItems(res?.data?.items || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
  refreshMappedItems();
}, [vendorToken, auth_token, org_token]);



const normalize = (v) => v?.trim().toLowerCase();
const capitalizeFirst = (v) => {
  const value = String(v || "").trim();
  if (!value) return "";
  return value.charAt(0).toUpperCase() + value.slice(1);
};
const categories = useMemo(() => {
  return Array.from(
    new Set(
      itemsData
        .map(i => normalize(i.category))
        .filter(Boolean)
    )
  );
}, [itemsData]);

const filteredItems = useMemo(() => {
  if (!selectedCategory) return itemsData;

  const selectedCat = normalize(selectedCategory);

  return itemsData.filter(
    i => normalize(i.category) === selectedCat
  );
}, [itemsData, selectedCategory]);

const bulkFilteredItems = useMemo(() => {
  const query = normalize(itemSearch);
  if (!query) return filteredItems;
  return filteredItems.filter((item) => {
    const name = normalize(item?.item_name || "");
    const code = normalize(item?.item_code || "");
    return name.includes(query) || code.includes(query);
  });
}, [filteredItems, itemSearch]);

const allBulkSelected = useMemo(() => {
  if (!bulkFilteredItems.length) return false;
  return bulkFilteredItems.every((item) =>
    selectedItemTokens.includes(item?.token)
  );
}, [bulkFilteredItems, selectedItemTokens]);


const selectedItemObj = useMemo(() => {
  if (!selectedItem) return null;

  return filteredItems.find(
    i => normalize(i.item_name) === normalize(selectedItem)
  );
}, [filteredItems, selectedItem]);


  const handleCategorySelect = (val) => {
    const category = String(val).trim();
    setSelectedCategory(category);
    setSelectedItem("");
    setItemSearch("");
    setSelectedItemTokens([]);
  };

   const handleItemSelect = (val) => {
    setSelectedItem(String(val).trim());
  };

const toggleBulkMode = (checked) => {
  setBulkMode(checked);
  setItemSearch("");
  setSelectedItemTokens([]);
  setSelectedItem("");
};

const toggleItemToken = (token) => {
  if (!token) return;
  setSelectedItemTokens((prev) =>
    prev.includes(token) ? prev.filter((t) => t !== token) : [...prev, token]
  );
};

const toggleSelectAllFiltered = () => {
  const tokens = bulkFilteredItems.map((item) => item?.token).filter(Boolean);
  if (!tokens.length) return;

  setSelectedItemTokens((prev) => {
    const prevSet = new Set(prev);
    const everySelected = tokens.every((t) => prevSet.has(t));
    if (everySelected) {
      return prev.filter((t) => !tokens.includes(t));
    }
    tokens.forEach((t) => prevSet.add(t));
    return Array.from(prevSet);
  });
};

const isSaveDisabled =
  loading || (bulkMode ? selectedItemTokens.length === 0 : !selectedItemObj?.token);

const handleSave = async () => {
  try {
    setLoading(true);

    if (!bulkMode) {
      if (!selectedItemObj?.token) {
        setStatus({
          show: true,
          type: "error",
          message: "Please select an item to map.",
        });
        return;
      }

      await axios.post(
        API_ENDPOINT.item_vendor_mapping_create,
        {
          vendor_token: vendorToken,
          organization_token: org_token,
          item_token: selectedItemObj?.token,
        },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );

      setMappedItems((prev) => [
        ...prev,
        {
          mapping_token: Date.now(),
          category: selectedItemObj.category,
          item_name: selectedItemObj.item_name,
          item_code: selectedItemObj.item_code,
          created_date: new Date().toISOString(),
        },
      ]);

      setSelectedCategory("");
      setSelectedItem("");

      setStatus({
        show: true,
        type: "success",
        message: "Item mapped successfully",
      });
      return;
    }

    if (selectedItemTokens.length === 0) {
      setStatus({
        show: true,
        type: "error",
        message: "Please select at least one item to map.",
      });
      return;
    }

    const tokensToMap = [...selectedItemTokens];
    const mapped = [];
    const alreadyMapped = [];
    const failed = [];

    for (const token of tokensToMap) {
      try {
        await axios.post(
          API_ENDPOINT.item_vendor_mapping_create,
          {
            vendor_token: vendorToken,
            organization_token: org_token,
            item_token: token,
          },
          { headers: { Authorization: `Bearer ${auth_token}` } }
        );
        mapped.push(token);
      } catch (err) {
        const apiError =
          err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.response?.data?.detail ||
          "";
        const apiErrorText = String(apiError || "").trim();
        const isAlready = apiErrorText.toLowerCase().includes("already mapped");
        if (isAlready) {
          alreadyMapped.push(token);
        } else {
          failed.push(token);
        }
      }
    }

    await refreshMappedItems();

    setSelectedItemTokens([]);
    setItemSearch("");

    const parts = [];
    if (mapped.length) parts.push(`${mapped.length} mapped`);
    if (alreadyMapped.length) parts.push(`${alreadyMapped.length} already mapped`);
    if (failed.length) parts.push(`${failed.length} failed`);

    setStatus({
      show: true,
      type: failed.length ? "error" : "success",
      message: parts.length ? parts.join(", ") : "No changes",
    });
  } catch (err) {
    console.error(err);
    const apiError =
      err?.response?.data?.error ||
      err?.response?.data?.message ||
      err?.response?.data?.detail ||
      "";
    const apiErrorText = String(apiError || "").trim();
    const isAlreadyMapped = apiErrorText.toLowerCase().includes("already mapped");
    setStatus({
      show: true,
      type: "error",
      message: isAlreadyMapped
        ? "Item already mapped"
        : apiErrorText || "Failed to map item",
    });
  } finally {
    setLoading(false);
  }
};

const handleStatusClose = () => {
  setStatus(prev => ({ ...prev, show: false }));
};

 
  return (

    <>
    <HeaderTitle titleText="Item Mapping" />
    <div style={{ width: "40rem", display: "flex", flexDirection: "column", gap: "1.2rem" }}>
      {/* CATEGORY */}
   <DropdownBtnOutlined
        label={selectedCategory ? capitalizeFirst(selectedCategory) : "Select Item Category"}
        options={categories.map(capitalizeFirst)}
        onClick={handleCategorySelect}
        btnWidth="100%"
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={bulkMode}
            onChange={(e) => toggleBulkMode(e.target.checked)}
            sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }}
          />
        }
        label={
          <Typography sx={{ fontSize: "14px", fontFamily: "gilroyMedium" }}>
            Map multiple items (bulk)
          </Typography>
        }
      />

      {/* ITEM */}
      {!bulkMode ? (
        <DropdownBtnOutlined
          label={selectedItem ? capitalizeFirst(selectedItem) : "Select Item Name"}
          options={[
            ...filteredItems.map((i) => capitalizeFirst(i.item_name?.trim() || "")),
          ]}
          onClick={handleItemSelect}
          btnWidth="100%"
          disabled={!selectedCategory}
        />
      ) : (
        <Box
          sx={{
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            padding: "12px",
            backgroundColor: "#fff",
          }}
        >
          <TextField
            size="small"
            fullWidth
            placeholder="Search items by name or code"
            value={itemSearch}
            onChange={(e) => setItemSearch(e.target.value)}
            disabled={!selectedCategory}
            inputProps={{
              style: { fontFamily: "gilroyMedium", fontSize: "14px" },
            }}
          />

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 1,
              mb: 1,
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={allBulkSelected}
                  onChange={toggleSelectAllFiltered}
                  disabled={!selectedCategory || bulkFilteredItems.length === 0}
                  sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }}
                />
              }
              label={
                <Typography sx={{ fontSize: "13px", fontFamily: "gilroyMedium" }}>
                  Select all (filtered)
                </Typography>
              }
              sx={{ m: 0 }}
            />

            <Typography
              sx={{
                fontSize: "13px",
                fontFamily: "gilroyMedium",
                color: "#475569",
              }}
            >
              Selected: {selectedItemTokens.length}
            </Typography>
          </Box>

          <Box
            sx={{
              maxHeight: 220,
              overflowY: "auto",
              border: "1px solid #f1f5f9",
              borderRadius: "6px",
              padding: "6px 8px",
            }}
          >
            {!selectedCategory ? (
              <Typography
                sx={{
                  fontSize: "13px",
                  fontFamily: "gilroyMedium",
                  color: "#64748b",
                  py: 1,
                }}
              >
                Select a category to load items
              </Typography>
            ) : bulkFilteredItems.length === 0 ? (
              <Typography
                sx={{
                  fontSize: "13px",
                  fontFamily: "gilroyMedium",
                  color: "#64748b",
                  py: 1,
                }}
              >
                No items found
              </Typography>
            ) : (
              bulkFilteredItems.map((item) => {
                const token = item?.token;
                const checked = selectedItemTokens.includes(token);
                const label = `${capitalizeFirst(item?.item_name)}${
                  item?.item_code ? ` (${item.item_code})` : ""
                }`;

                return (
                  <FormControlLabel
                    key={token}
                    control={
                      <Checkbox
                        checked={checked}
                        onChange={() => toggleItemToken(token)}
                        sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }}
                      />
                    }
                    label={
                      <Typography sx={{ fontSize: "13px", fontFamily: "gilroyMedium" }}>
                        {label || "-"}
                      </Typography>
                    }
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      m: 0,
                      width: "100%",
                    }}
                  />
                );
              })
            )}
          </Box>
        </Box>
      )}

      {/* SAVE BUTTON */}
      <DButton
        label="Save Item Mapping"
        loadingState={loading}
        onClick={handleSave}
        buyerBtn={true}
        disabled={isSaveDisabled}
        tooltipMessage={
          isSaveDisabled && !loading
            ? bulkMode
              ? "Select at least one item to enable save."
              : "Select an item category and item name to enable save."
            : ""
        }
      />

      {error && <span style={{ color: "red" }}>{error}</span>}

{status.show && (
  <Modal
    open={Boolean(status.show)}
    closeAfterTransition
    onClose={handleStatusClose}
    slotProps={{ backdrop: { TransitionComponent: Fade } }}
    sx={{ overflow: "auto" }}
  >
    <Fade in={Boolean(status.show)}>
      <Box>
        <SuccessPopupDashboard
          popupImage={status.type === "success" ? successPopupImg : deletePopupImg}
          popupHeroText={status.type === "success" ? "Success" : "Error"}
          popupDescription={status.message}
          popBtn={true}
          btnText={"Okay"}
          btnClick={handleStatusClose}
          buyerBtn={true}
          buyerBtnOutline={true}
        />
      </Box>
    </Fade>
  </Modal>
)}

</div>

 <div >
  {mappedItems.length > 0 && (
 <>

   <HeaderTitle titleText={"Mapped Item"} />
 
  <TableContainer
    component={Paper}
    sx={{
      mt: 2,
      width: "100%",
      overflowX: "auto",
    }}
  >
    <Table size="small">
      <TableHead >
        <TableRow sx={{ backgroundColor: "#8fc9f834"}}>
          <TableCell  sx={{fontSize:"14px",fontWeight:"bold",fontFamily:"gilroyMedium" }}>Sl.No</TableCell>
          <TableCell  sx={{fontSize:"14px",fontWeight:"bold",fontFamily:"gilroyMedium"}}>Category</TableCell>
          <TableCell  sx={{fontSize:"14px",fontWeight:"bold",fontFamily:"gilroyMedium"}}>Item Name</TableCell>
          <TableCell  sx={{fontSize:"14px",fontWeight:"bold",fontFamily:"gilroyMedium"}}>Item Code</TableCell>
          <TableCell  sx={{fontSize:"14px",fontWeight:"bold",fontFamily:"gilroyMedium"}}>Mapped Date</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {mappedItems.map((item, index) => (
          <TableRow key={item.mapping_token || item?.token || index}>
            <TableCell  sx={{fontSize:"14px",fontFamily:"gilroyMedium"}}>{index + 1}</TableCell>
            <TableCell  sx={{fontSize:"14px",fontFamily:"gilroyMedium"}}>{item.category || item?.item?.category || "-"}</TableCell>
            <TableCell  sx={{fontSize:"14px",fontFamily:"gilroyMedium"}}>{item.item_name || item?.item?.item_name || "-"}</TableCell>
            <TableCell  sx={{fontSize:"14px",fontFamily:"gilroyMedium"}}>{item.item_code || item?.item?.item_code || "-"}</TableCell>
            <TableCell sx={{fontSize:"14px",fontFamily:"gilroyMedium"}}>
              {item.created_date
                ? new Date(item.created_date).toLocaleDateString()
                : item.created_on
                  ? new Date(item.created_on).toLocaleDateString()
                  : "-"}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
 </>
)}
 </div>
    </>
    



  )

  
}

  




export default VendorItemMapping;
